import React from "react";
import "./App.css";
import lockupHorizontal from "./assets/brand/lockup-horizontal.svg";

const updated = new Date().toLocaleDateString("en-GB", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

export default function Terms({ onClose }) {
  return (
    <div className="legal-page">
      <nav className="landing-nav">
        <div className="landing-nav-brand">
          <img
            src={lockupHorizontal}
            alt="SuqPOS"
            style={{ height: "36px", width: "auto" }}
          />
        </div>
        <div className="landing-nav-actions">
          <button className="report-close" onClick={onClose}>
            ✕
          </button>
        </div>
      </nav>

      <article className="legal-content">
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-updated">Last updated: {updated}</p>

        <h2>Agreement</h2>
        <p>
          By creating a SuqPOS account or using the SuqPOS application, you
          agree to these terms. If you don't agree, please don't use
          SuqPOS.
        </p>
        <p>
          SuqPOS is currently in a pilot phase, operated by Teccane
          Solutions. These terms will be updated as the service matures.
        </p>

        <h2>What SuqPOS is</h2>
        <p>
          SuqPOS is a point-of-sale and inventory management application
          for retail stores, currently focused on small mini-marts in
          Ethiopia. It includes offline-capable sales processing, inventory
          tracking, staff management, and reporting.
        </p>

        <h2>Account responsibilities</h2>
        <ul>
          <li>You're responsible for keeping your login credentials secure</li>
          <li>
            You're responsible for the accuracy of the data you enter
            (product prices, stock levels, sales records)
          </li>
          <li>
            If you're a store manager, you're responsible for the accounts
            of any staff you create and for their appropriate use of the
            system
          </li>
          <li>You agree not to use SuqPOS for any unlawful purpose</li>
        </ul>

        <h2>Pilot phase</h2>
        <p>
          SuqPOS is currently in active pilot use. Features, pricing, and
          availability may change as the product develops. We'll do our
          best to communicate significant changes to pilot users in
          advance.
        </p>

        <h2>Availability and offline use</h2>
        <p>
          SuqPOS is designed to keep working during network interruptions
          by queuing sales locally and syncing when connectivity returns.
          We aim for high reliability but don't guarantee uninterrupted
          service. We're not liable for data loss or business disruption
          caused by extended offline periods, device failure, or events
          outside our reasonable control.
        </p>

        <h2>Fees</h2>
        <p>
          Billing is not yet active during this pilot phase. When paid
          plans launch, pricing and payment terms will be presented
          clearly before you're charged, and these terms will be updated
          accordingly.
        </p>

        <h2>Data ownership</h2>
        <p>
          You own the business data you enter into SuqPOS (products,
          sales, customers, staff records). We store and process it on
          your behalf as described in our Privacy Policy. If you stop
          using SuqPOS, you can request an export of your data by
          contacting suqpos@zoho.com.
        </p>

        <h2>Termination</h2>
        <p>
          You can stop using SuqPOS at any time. We may suspend or
          terminate an account that violates these terms, is used
          unlawfully, or — during the pilot phase — if we need to make
          changes to how the pilot operates. We'll give reasonable notice
          where practical.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          SuqPOS is provided "as is" during this pilot phase. To the
          extent permitted by applicable law, we are not liable for
          indirect, incidental, or consequential damages arising from your
          use of the app, including lost sales, lost data, or business
          interruption. Nothing in these terms limits liability that
          cannot be limited under Ethiopian law.
        </p>

        <h2>Governing law</h2>
        <p>These terms are governed by the laws of Ethiopia.</p>

        <h2>Changes to these terms</h2>
        <p>
          We may update these terms as SuqPOS develops. We'll update the
          "Last updated" date when we do. Continued use after changes
          means you accept the updated terms.
        </p>

        <h2>Contact</h2>
        <p>Questions about these terms: suqpos@zoho.com</p>
      </article>

      <footer className="landing-footer">
        <div className="landing-footer-brand">
          <img
            src={lockupHorizontal}
            alt="SuqPOS"
            style={{ height: "24px", width: "auto", verticalAlign: "middle" }}
          />
        </div>
        <p style={{ fontSize: "12px", color: "var(--text3)", marginTop: "8px" }}>
          © {new Date().getFullYear()} SuqPOS · Smart Sales · Anywhere
        </p>
      </footer>
    </div>
  );
}
